import React from "react";
import { Alert, Form, FormGroup, Input, Spinner } from "reactstrap";

import "./styles.scss";

import { Actions, JobState, LoggedInState, State } from "../../../types";
import { EmptyList } from "./EmptyList";
import { Pagination } from "./Pagination";
import { PopulatedList } from "./PopulatedList";
import { JobListState, useJobListState } from "./useJobListState";

type Props = Readonly<{
  actions: Actions;
  auth: LoggedInState;
  blockingStep: string;
  jobs: State["jobs"];
  jobState: State["job"];
}>;
export const JobList = ({
  actions: { abortJob, updateJobs },
  auth,
  blockingStep,
  jobs,
  jobState,
}: Props) => {
  const [
    jobListState,
    jobIds,
    pageNumber,
    totalPages,
    totalJobs,
    textFilter,
    nextPage,
    prevPage,
    retry,
    setTextFilter,
  ] = useJobListState(auth, blockingStep, jobs, updateJobs);
  if (jobListState === JobListState.fetching) {
    return (
      <div className="text-center">
        <Spinner />
        <br />
        Loading &hellip;
      </div>
    );
  }
  let contents = null;
  if (jobListState === JobListState.failed) {
    contents = (
      <Alert color="danger">
        <strong>
          An error occurred while retrieving job list.{" "}
          <a
            className="alert-link"
            href="#"
            onClick={e => {
              e.preventDefault();
              retry();
            }}
          >
            Retry
          </a>
        </strong>
      </Alert>
    );
  } else if (jobListState === JobListState.ready) {
    if (jobIds.length < 1) {
      contents = <EmptyList />;
    } else {
      let activeJobId = null;
      if (jobState.state === JobState.loading) {
        activeJobId = jobState.jobId;
      } else if (jobState.state === JobState.ready) {
        activeJobId = jobState.job.id;
      }
      contents = (
        <PopulatedList
          abortJob={abortJob}
          activeJobId={activeJobId}
          jobIds={jobIds}
          jobs={jobs}
          user={auth.user}
        />
      );
    }
  }

  return (
    <div className="job-list">
      <Pagination
        currentJobs={jobIds.length}
        currentPage={pageNumber + 1}
        nextPage={nextPage}
        prevPage={prevPage}
        totalJobs={totalJobs}
        totalPages={totalPages}
      />
      <Form>
        <FormGroup className="search-group">
          <i className="fa fa-search" />
          <Input
            className="search-entry"
            disabled={Object.keys(jobs).length < 1}
            onChange={e => {
              e.stopPropagation();
              setTextFilter(e.target.value);
            }}
            placeholder="Search"
            type="search"
            value={textFilter}
          />
        </FormGroup>
      </Form>
      <div className="job-list-contents">{contents}</div>
    </div>
  );
};
JobList.displayName = "JobList";
